// Import: Middleware Action & Custom Types
import {
    CLEAN_ORDERS_BY_PRODUCT,
    CLEAN_ORDERS_BY_PRODUCT_ERROR,
} from "_models/redux/types";

// Action function
export const cleanOrdersByProductAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            payload: undefined,
            type: CLEAN_ORDERS_BY_PRODUCT,
        });
    } catch (e) {
        dispatch({
            payload: undefined,
            type: CLEAN_ORDERS_BY_PRODUCT_ERROR,
        });
    }
};
